export const apiConfig = {
  timeeRegisterCustomHeader: 'X-REQUESTED-BY-TIMEE-REGISTER-API',
  retryWaitMillSec: 300,
} as const;
